/** Other documents additional data */
export class Metadata {
	/** Documents id */
	id: number;
	/** Documents file name */
	filename: string;
	/** Documents uploaded date */
	uploadedDate: string;
	/** Documents last modified date */
	lastModifiedDate: string;
	/** Documents file size */
	fileSize: string;
	/** Documents extension */
	extension: string;
	/** Documents category */
	category: string;
	/** Documents description */
	description: string;
	/** Documents sort order */
	sortOrder: number;
	/** User epmsPID */
	epmsPID: string;
}

/** Documents data */
export class Document {
	/** Documents key */
	key: string;
	/** Documents metadata */
	metadata: Metadata;
	/** Documents body */
	body: any;
}

/** Document resolved data */
export interface DocumentResolved {
	/** Documents data */
	document: Document;
	/** Documents error */
	error?: any;
}
